// Service Order (Phiếu dịch vụ xưởng — BDSC + Bảo hiểm) constants.
// Sync với BE enum: backend/src/common/enum/service-order.enum.ts
//   - SO_STATUS     (11 trạng thái)
//   - SERVICE_TYPE  (BDSC / GBH)
//   - MRQ_STATUS    (PENDING / ISSUED / CLOSED / CANCELLED)
// BE resource REST = `service-orders`. Permission FE check theo `SERVICE_ORDER_*`.

export const SO_STATUS = {
  QUOTING: 'QUOTING',
  QUOTED: 'QUOTED',
  REPAIRING: 'REPAIRING',
  PENDING_PARTS: 'PENDING_PARTS',
  PARTS_ISSUED: 'PARTS_ISSUED',
  INSPECTING: 'INSPECTING',
  INSPECTED: 'INSPECTED',
  SETTLING: 'SETTLING',
  SETTLED: 'SETTLED',
  RELEASED: 'RELEASED',
  CANCELLED: 'CANCELLED',
};

export const SO_STATUS_LABEL = {
  [SO_STATUS.QUOTING]: 'Đang báo giá',
  [SO_STATUS.QUOTED]: 'Đã báo giá',
  [SO_STATUS.REPAIRING]: 'Đang sửa chữa',
  [SO_STATUS.PENDING_PARTS]: 'Chờ xuất vật tư',
  [SO_STATUS.PARTS_ISSUED]: 'Đã xuất vật tư',
  [SO_STATUS.INSPECTING]: 'Đang nghiệm thu',
  [SO_STATUS.INSPECTED]: 'Đã nghiệm thu',
  [SO_STATUS.SETTLING]: 'Đang quyết toán',
  [SO_STATUS.SETTLED]: 'Đã quyết toán',
  [SO_STATUS.RELEASED]: 'Đã xuất xưởng',
  [SO_STATUS.CANCELLED]: 'Đã hủy',
};

// BootstrapVue b-badge variant — dùng cho list/table.
export const SO_STATUS_VARIANT = {
  [SO_STATUS.QUOTING]: 'secondary',
  [SO_STATUS.QUOTED]: 'info',
  [SO_STATUS.REPAIRING]: 'primary',
  [SO_STATUS.PENDING_PARTS]: 'warning',
  [SO_STATUS.PARTS_ISSUED]: 'primary',
  [SO_STATUS.INSPECTING]: 'warning',
  [SO_STATUS.INSPECTED]: 'info',
  [SO_STATUS.SETTLING]: 'warning',
  [SO_STATUS.SETTLED]: 'success',
  [SO_STATUS.RELEASED]: 'dark',
  [SO_STATUS.CANCELLED]: 'danger',
};

// Icon FontAwesome theo status (badge ở row). Khi đổi màu icon nhớ
// `color: inherit !important` ở SCSS (frontend-styling rule #1).
export const SO_STATUS_ICON = {
  [SO_STATUS.QUOTING]: 'fas fa-file-invoice-dollar',
  [SO_STATUS.QUOTED]: 'fas fa-file-signature',
  [SO_STATUS.REPAIRING]: 'fas fa-wrench',
  [SO_STATUS.PENDING_PARTS]: 'fas fa-hourglass-half',
  [SO_STATUS.PARTS_ISSUED]: 'fas fa-dolly',
  [SO_STATUS.INSPECTING]: 'fas fa-search',
  [SO_STATUS.INSPECTED]: 'fas fa-clipboard-check',
  [SO_STATUS.SETTLING]: 'fas fa-calculator',
  [SO_STATUS.SETTLED]: 'fas fa-check-circle',
  [SO_STATUS.RELEASED]: 'fas fa-flag-checkered',
  [SO_STATUS.CANCELLED]: 'fas fa-ban',
};

// Soft bg + text color cho status pill (Metronic palette).
export const SO_STATUS_PILL = {
  [SO_STATUS.QUOTING]: { bg: '#E4E6EF', color: '#3F4254' },
  [SO_STATUS.QUOTED]: { bg: '#E1E9FF', color: '#3699FF' },
  [SO_STATUS.REPAIRING]: { bg: '#E1E9FF', color: '#3699FF' },
  [SO_STATUS.PENDING_PARTS]: { bg: '#FFF4DE', color: '#FFA800' },
  [SO_STATUS.PARTS_ISSUED]: { bg: '#E1E9FF', color: '#3699FF' },
  [SO_STATUS.INSPECTING]: { bg: '#FFF4DE', color: '#FFA800' },
  [SO_STATUS.INSPECTED]: { bg: '#E1E9FF', color: '#3699FF' },
  [SO_STATUS.SETTLING]: { bg: '#FFF4DE', color: '#FFA800' },
  [SO_STATUS.SETTLED]: { bg: '#C9F7F5', color: '#1BC5BD' },
  [SO_STATUS.RELEASED]: { bg: '#D1D3E0', color: '#181C32' },
  [SO_STATUS.CANCELLED]: { bg: '#FFE2E5', color: '#F64E60' },
};

// Options dropdown filter (b-form-select dạng { value, text }).
export const SO_STATUS_OPTIONS = Object.values(SO_STATUS).map((v) => ({
  value: v,
  text: SO_STATUS_LABEL[v] || v,
}));

// Loại dịch vụ — sync SERVICE_TYPE (BE enum).
export const SERVICE_TYPE = {
  BDSC: 'BDSC',
  GBH: 'GBH',
};

export const SERVICE_TYPE_LABEL = {
  [SERVICE_TYPE.BDSC]: 'Bảo dưỡng - Sửa chữa',
  [SERVICE_TYPE.GBH]: 'Giám định bảo hiểm',
};

export const SERVICE_TYPE_OPTIONS = Object.values(SERVICE_TYPE).map((v) => ({
  value: v,
  text: SERVICE_TYPE_LABEL[v] || v,
}));

// Trạng thái phiếu yêu cầu vật tư — sync MRQ_STATUS (BE enum).
export const MRQ_STATUS = {
  PENDING: 'PENDING',
  ISSUED: 'ISSUED',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED',
};

export const MRQ_STATUS_LABEL = {
  [MRQ_STATUS.PENDING]: 'Chờ phát hàng',
  [MRQ_STATUS.ISSUED]: 'Đã phát hàng',
  [MRQ_STATUS.CLOSED]: 'Đã quyết toán',
  [MRQ_STATUS.CANCELLED]: 'Đã hủy',
};

export const MRQ_STATUS_VARIANT = {
  [MRQ_STATUS.PENDING]: 'warning',
  [MRQ_STATUS.ISSUED]: 'primary',
  [MRQ_STATUS.CLOSED]: 'success',
  [MRQ_STATUS.CANCELLED]: 'danger',
};

export const MRQ_STATUS_OPTIONS = Object.values(MRQ_STATUS).map((v) => ({
  value: v,
  text: MRQ_STATUS_LABEL[v] || v,
}));

// ---- Báo giá (SO-002) ----

// Kiểu chiết khấu — sync DISCOUNT_TYPE (BE common/enum). Mặc định AMOUNT (đ).
export const DISCOUNT_TYPE = {
  AMOUNT: 'AMOUNT',
  PERCENT: 'PERCENT',
};

export const DISCOUNT_TYPE_LABEL = {
  [DISCOUNT_TYPE.AMOUNT]: 'đ',
  [DISCOUNT_TYPE.PERCENT]: '%',
};

// Thuế suất VAT — sync VAT_TYPE (BE product.enum). Giá trị = chuỗi lưu DB.
export const VAT_TYPE_OPTIONS = [
  { value: 'KCT', text: 'KCT' },
  { value: '0%', text: '0%' },
  { value: '5%', text: '5%' },
  { value: '8%', text: '8%' },
  { value: '10%', text: '10%' },
];

// Map VAT_TYPE ('10%') → thuế suất số (10). Mirror BE so-calc.vatTypeToRate.
export function vatTypeToRate(vatType) {
  if (!vatType) return 0;
  const s = String(vatType).trim();
  if (s.endsWith('%')) {
    const v = parseFloat(s.slice(0, -1));
    return Number.isNaN(v) ? 0 : v;
  }
  return 0;
}

// ---- Workflow SO-003 (state machine lite — MIRROR BE) ----
// Nguồn chân lý: backend so-state-machine.helper.ts. FE chỉ render CTA/step theo dữ liệu này;
// BE vẫn assertAdvance/assertCancellable nên FE không tự quyết hợp lệ — chỉ ẩn/disable nút.

// Phase nghiệp vụ cao nhất đã triển khai — đồng bộ SO_MAX_IMPLEMENTED_PHASE bên BE.
// Phase 6 chỉ mở "Xuất xưởng" (SETTLED→RELEASED). HĐ đỏ VAT + công nợ BH = kế toán thủ công.
// Phase 5 = Quyết toán (SO-007) — hiện DEMO (duyệt mô hình tick-per-dòng, chưa xuất HĐ VAT thật).
export const SO_MAX_IMPLEMENTED_PHASE = 6;

// Quyền RBAC SO (string khớp BE LIST_PERMISSION) — dùng checkPermissions().
export const SO_PERMISSION = {
  VIEW: 'SERVICE_ORDER_VIEW',
  QUOTE_EDIT: 'SERVICE_ORDER_QUOTE_EDIT',
  ADVANCE: 'SERVICE_ORDER_ADVANCE',
  CANCEL: 'SERVICE_ORDER_CANCEL',
  MRQ_VIEW: 'SERVICE_ORDER_MRQ_VIEW',
  MRQ_CREATE: 'SERVICE_ORDER_MRQ_CREATE',
  MRQ_ISSUE: 'SERVICE_ORDER_MRQ_ISSUE',
  MRQ_RETURN: 'SERVICE_ORDER_MRQ_RETURN',
  SETTLE: 'SERVICE_ORDER_SETTLE',
  SETTLE_VIEW: 'SERVICE_ORDER_SETTLE_VIEW',
};

// 7 bước workflow (SRS dòng 898). Index 1..7 dùng cho thanh tiến trình.
export const SO_STEPS = [
  { index: 1, label: 'Tiếp nhận' },
  { index: 2, label: 'Báo giá' },
  { index: 3, label: 'Lệnh SC' },
  { index: 4, label: 'Xuất vật tư' },
  { index: 5, label: 'Nghiệm thu' },
  { index: 6, label: 'Quyết toán' },
  { index: 7, label: 'Xuất xưởng' },
];

// Map 11 status → bước (1..7). CANCELLED → null (không map bước, hiển thị mờ + banner đỏ).
export const SO_STEP_INDEX = {
  [SO_STATUS.QUOTING]: 2,
  [SO_STATUS.QUOTED]: 2,
  [SO_STATUS.REPAIRING]: 3,
  [SO_STATUS.PENDING_PARTS]: 4,
  [SO_STATUS.PARTS_ISSUED]: 4,
  [SO_STATUS.INSPECTING]: 5,
  [SO_STATUS.INSPECTED]: 5,
  [SO_STATUS.SETTLING]: 6,
  [SO_STATUS.SETTLED]: 6,
  [SO_STATUS.RELEASED]: 7,
  [SO_STATUS.CANCELLED]: null,
};

// Toàn bộ transition TIẾN BƯỚC (mirror SO_TRANSITIONS bên BE). `phase` đánh dấu bước nào
// thực thi được (phase ≤ SO_MAX_IMPLEMENTED_PHASE). `requires` = điều kiện kèm.
export const SO_TRANSITIONS = [
  {
    from: SO_STATUS.QUOTING,
    to: SO_STATUS.QUOTED,
    action: 'Duyệt báo giá',
    permission: SO_PERMISSION.QUOTE_EDIT,
    phase: 2,
  },
  {
    from: SO_STATUS.QUOTED,
    to: SO_STATUS.REPAIRING,
    action: 'Duyệt lệnh SC',
    permission: SO_PERMISSION.ADVANCE,
    phase: 3,
    requires: 'customerConfirmed',
  },
  {
    // Side-effect của TẠO MRQ — KHÔNG gọi /advance trần (BE chặn). FE render nút "Tạo MRQ".
    from: SO_STATUS.REPAIRING,
    to: SO_STATUS.PENDING_PARTS,
    action: 'Tạo phiếu vật tư (MRQ)',
    permission: SO_PERMISSION.MRQ_CREATE,
    phase: 4,
    trigger: 'mrqCreate',
  },
  {
    from: SO_STATUS.REPAIRING,
    to: SO_STATUS.INSPECTING,
    action: 'Chuyển nghiệm thu (không vật tư)',
    permission: SO_PERMISSION.ADVANCE,
    phase: 4,
  },
  {
    // Side-effect của PHÁT vật tư — KHÔNG gọi /advance trần (BE chặn).
    from: SO_STATUS.PENDING_PARTS,
    to: SO_STATUS.PARTS_ISSUED,
    action: 'Xác nhận xuất vật tư',
    permission: SO_PERMISSION.MRQ_ISSUE,
    phase: 4,
    trigger: 'mrqIssue',
  },
  {
    from: SO_STATUS.PARTS_ISSUED,
    to: SO_STATUS.INSPECTING,
    action: 'Sang nghiệm thu',
    permission: SO_PERMISSION.ADVANCE,
    phase: 4,
  },
  {
    from: SO_STATUS.INSPECTING,
    to: SO_STATUS.INSPECTED,
    action: 'Duyệt nghiệm thu',
    permission: SO_PERMISSION.ADVANCE,
    phase: 4,
  },
  {
    // Side-effect của BẮT ĐẦU QUYẾT TOÁN — KHÔNG gọi /advance trần (dùng /settlement/start để
    // sinh dòng nháp). FE render nút "Bắt đầu quyết toán".
    from: SO_STATUS.INSPECTED,
    to: SO_STATUS.SETTLING,
    action: 'Bắt đầu quyết toán',
    permission: SO_PERMISSION.SETTLE,
    phase: 5,
    trigger: 'settlementStart',
  },
  {
    // Side-effect của DUYỆT QUYẾT TOÁN — dùng /settlement/confirm (đánh dấu draft CONFIRMED).
    from: SO_STATUS.SETTLING,
    to: SO_STATUS.SETTLED,
    action: 'Duyệt quyết toán',
    permission: SO_PERMISSION.SETTLE,
    phase: 5,
    trigger: 'settlementConfirm',
  },
  {
    from: SO_STATUS.SETTLED,
    to: SO_STATUS.RELEASED,
    action: 'Xuất xưởng',
    permission: SO_PERMISSION.ADVANCE,
    phase: 6,
  },
];

// Ma trận huỷ (mirror CANCEL_MATRIX). MVP Phase 3 huỷ QUOTING/QUOTED/REPAIRING (phase 3).
export const SO_CANCEL_MATRIX = {
  [SO_STATUS.QUOTING]: { allowed: true, phase: 3 },
  [SO_STATUS.QUOTED]: { allowed: true, phase: 3 },
  [SO_STATUS.REPAIRING]: { allowed: true, phase: 3 },
  [SO_STATUS.PENDING_PARTS]: { allowed: true, phase: 4 },
  [SO_STATUS.PARTS_ISSUED]: { allowed: true, phase: 4 },
  [SO_STATUS.INSPECTING]: { allowed: true, phase: 4 },
  [SO_STATUS.INSPECTED]: { allowed: true, phase: 4 },
  // ⚠ SETTLING/SETTLED để phase 7 (> SO_MAX 6) — KHÔNG cho huỷ quyết toán (khớp BE CANCEL_MATRIX).
  // Cần void bill + hoàn VT + chặn nếu đã có HĐ VAT — kế toán xử lý thủ công ngoài hệ thống.
  [SO_STATUS.SETTLING]: { allowed: true, phase: 7 },
  [SO_STATUS.SETTLED]: { allowed: true, phase: 7 },
  [SO_STATUS.RELEASED]: { allowed: false, phase: 0 },
  [SO_STATUS.CANCELLED]: { allowed: false, phase: 0 },
};

// Bước tiến kế tiếp từ 1 status (transition phase nhỏ nhất). Mirror nextAdvance() bên BE.
// Trả về transition (kèm cờ `enabled` = phase đã triển khai) hoặc null nếu là bước cuối.
// ⚠ KHÔNG dùng cho REPAIRING (có 2 transition cùng phase → không phân biệt được). Dùng
// `advanceActionsFrom` để render đầy đủ các hành động (vd REPAIRING: Tạo MRQ + Chuyển nghiệm thu).
export function nextAdvance(status) {
  const list = SO_TRANSITIONS.filter((t) => t.from === status).sort(
    (a, b) => a.phase - b.phase
  );
  const t = list[0];
  if (!t) return null;
  return { ...t, enabled: t.phase <= SO_MAX_IMPLEMENTED_PHASE };
}

// TẤT CẢ transition tiến bước hợp lệ từ 1 status (mỗi cái kèm cờ `enabled`). Dùng cho màn Detail
// render đúng số nút CTA (REPAIRING → 2 nút). `trigger` cho biết nút mở luồng MRQ (mrqCreate/mrqIssue)
// thay vì gọi /advance trần.
export function advanceActionsFrom(status) {
  return SO_TRANSITIONS.filter((t) => t.from === status).map((t) => ({
    ...t,
    enabled: t.phase <= SO_MAX_IMPLEMENTED_PHASE,
  }));
}

// Khả năng huỷ tại 1 status. `enabled` = phase huỷ đã triển khai (Phase 3).
export function cancellableFrom(status) {
  const rule = SO_CANCEL_MATRIX[status] || { allowed: false, phase: 0 };
  return {
    ...rule,
    enabled: rule.allowed && rule.phase <= SO_MAX_IMPLEMENTED_PHASE,
  };
}
